import { useQuery } from "@apollo/client";
import { Test } from "types/graphql";
import { GET_TEST_CASES_TAB_DATA } from "./test_cases_tab_query";
import { useEffect } from "react";
import { TestCasesData } from "types/test_cases";

const mergeTestCasesData = (prev: TestCasesData, { fetchMoreResult }: { fetchMoreResult: TestCasesData }) => ({
  platformTest: {
    ...prev.platformTest,
    cases: {
      ...fetchMoreResult.platformTest.cases,
      edges: prev.platformTest.cases.edges.concat(fetchMoreResult.platformTest.cases.edges),
    },
  },
});

function useTestCasesTabData(testId?: string) {
  const { loading, data, fetchMore } = useQuery(GET_TEST_CASES_TAB_DATA, {
    variables: {
      testId,
      first: 1000, //DEFAULT_MAX_PAGE_SIZE = 1000  (customer_portal/graph.rb)
      after: null,
    },
    skip: !testId,
  });

  useEffect(() => {
    if (data?.platformTest?.cases?.pageInfo?.hasNextPage) {
      fetchMore({
        variables: {
          after: data.platformTest.cases.pageInfo.endCursor,
        },
        updateQuery: mergeTestCasesData,
      });
    }
  }, [data, fetchMore, mergeTestCasesData]);

  const platformTest = data?.platformTest;

  return {
    isLoading: loading,
    testWindow: platformTest?.testWindow,
    testCases: extractTestCases(platformTest),
  };
}

function extractTestCases(platformTest?: Test) {
  return platformTest?.cases?.edges?.map(testCase => testCase?.node).filter(testCase => !!testCase) || [];
}

export { useTestCasesTabData };
